// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","wrapper":"showSimilarLabel_wrapper__BDCEi","showSimilarBtn":"showSimilarLabel_showSimilarBtn__ypF6M"};